export const parseNewFiles = (
  files: string[],
  setLeftUrl: (url: string) => void,
  setRightUrl: (url: string) => void,
) => {
  const leftFile = files
    .filter((file) => {
      const parts = file.toLowerCase().split(/[_\-.]/); // the separator could be _, - or .
      return (
        parts.includes('l') || parts.includes('left') || parts.includes('os')
      );
    })
    .pop();

  const rightFile = files
    .filter((file) => {
      const parts = file.toLowerCase().split(/[_\-.]/);
      return (
        parts.includes('r') || parts.includes('right') || parts.includes('od')
      );
    })
    .pop();

  if (leftFile) {
    setLeftUrl(leftFile);
  }
  if (rightFile) {
    setRightUrl(rightFile);
  }
};
